$shm_hitalama_map_widget_float_form_custom $shm_hitalama_map_widget_float
	controls /
		<= Widget_page $shm_hitalama_map_widget_float_page
			name? <=> title?
			content <= page_content / <= Form
		<= Form $mol_form
			form_fields <= form_fields /
				<= Field*0 $mol_form_field
					name <= field_name* \
					bid <= field_bid* \
					Content <= Field_content* $mol_view
			submit_allowed => submit_allowed
			buttons <= buttons /
				<= Actions $mol_row
					sub /
						<= Publish $shm_hitalama_form_submit
							title \Отправить
							click? <=> submit? null
							enabled <= submit_allowed
						<= Clear_actions $mol_view
							sub /
								^ clear_button_visible /
									<= Clear $mol_button_minor
										title \Очистить
										click? <=> clear_ask? null
								^ clear_confirm_visible /
									<= Clear_confirm $mol_button_major
										title \Подтвердить очистку
										click? <=> clear_confirm? null
									<= Clear_cancel $mol_button_minor
										title \Отмена
										click? <=> clear_cancel? null
				^ submit_result_visible /
					<= Submit_result $mol_status
						message <= submit_result? \
						style *
							color \var(--shm_theme_success)
	clear_asked? false
	custom $shm_hitalama_map_widget_entity_form_custom
	Content_by_type* *
		any
			<= String*
		string
			<= String* $shm_hitalama_map_widget_float_form_string
				value? <=> field_value*? null
		textarea
			<= Textarea* $mol_textarea
				value? <=> field_value*?
		date
			<= Date* $shm_date_view
				value? <=> field_value*?
		number
			<= Number* $mol_number
				value? <=> field_number*? NaN
		period
			<= Period* $shm_period
				period? <=> field_value*?
				period_str => period_str*
		file
			<= File* $shm_hitalama_file_attach
				files? <=> field_files*? /
				value? <=> field_value*?
		file_pb
			<= File_pb* $shm_hitalama_file_attach_pb
				value? <=> field_value*?
				map_id <= pb_map_id \
				widget_id <= pb_widget_id \
				field_name <= field_name* \
		atom_link
			<= Atom_link* $shm_hitalama_map_widget_float_table_relation_atom
				value? <=> field_value*? null
				dictionary <= field_link_options* *
				active <= field_relation_active* \
				open? <=> field_relation_open*? \
				create? <=> field_relation_create*? null
		list_link
			<= List_link* $shm_hitalama_map_widget_float_table_relation_list
				value? <=> field_list_value*? /string
				dictionary <= field_link_options* *
				active <= field_relation_active* \
				open? <=> field_relation_open*? \
				create? <=> field_relation_create*? null
		select
			<= Select* $mol_select
				value? <=> field_value*? null
				dictionary <= field_select_dictionary* *
				Filter null
		json
			<= Json* $mol_textarea
				value? <=> field_json*? \
				hint \{"ключ":"значение"}
	pb_map_id \
	pb_widget_id \
	submit_result? \
	settings_content /
		<= Buttons_visible $mol_check_box
			title \Показывать кнопки
			checked? <=> buttons_visible? true
	-
		<= Buttons_visible $mol_view
			sub /
				<= Min_label $mol_paragraph
					title \Min
				<= Min $mol_number
					value? <=> min?
		<= Max_row $mol_view
			sub /
				<= Max_label $mol_paragraph
					title \Max
				<= Max $mol_number
					value? <=> max?
		<= Step_row $mol_view
			sub /
				<= Step_label $mol_paragraph
					title \Step
				<= Step $mol_number
					value? <=> step?
					precision 0.01
					precision_change 1
